"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _CustomSelect = _interopRequireDefault(require("./CustomSelect"));
var _CustomTextField = _interopRequireDefault(require("./CustomTextField"));
var _getResource = require("../../utilities/getResource");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    centerText: {
      textAlign: 'center'
    }
  };
};
var CustomTechnologyPlans = /*#__PURE__*/function (_Component) {
  function CustomTechnologyPlans(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomTechnologyPlans);
    _this = _callSuper(this, CustomTechnologyPlans, [props]);
    //Convert the string value into an array of arrays representing the rows
    var rows = [];
    var planValues = props.value ? props.value.map(function (v, index) {
      var tp = JSON.parse(v);
      var technologyID = tp.technologyID;
      var typeOfInvestment = (0, _lodash.find)(props.typesOfInvestment, {
        value: tp.typeOfInvestmentID
      });
      var yearOfContract = (0, _lodash.find)(props.yearOfContract, {
        value: tp.yearOfContractID
      });
      var purchaseOrInstallationPlan = tp.purchaseOrInstallationPlan;
      return {
        id: index,
        technologyID: technologyID ? technologyID : '',
        typeOfInvestment: typeOfInvestment ? typeOfInvestment : '',
        yearOfContract: yearOfContract ? yearOfContract : '',
        purchaseOrInstallationPlan: purchaseOrInstallationPlan ? purchaseOrInstallationPlan === '298' : ''
      };
    }) : [];
    var counter = 0;
    var techDupCheck = [];
    Object.keys(props.entity.data.technologyQuestions).forEach(function (t) {
      if (techDupCheck.indexOf(t) === -1) {
        techDupCheck.push(t);
        var technology = (0, _lodash.find)(props.technologiesList, {
          value: Number(t)
        });
        var techPlan = (0, _lodash.find)(planValues, {
          technologyID: t
        });
        rows.push({
          id: counter++,
          technologyID: t,
          technologyName: technology ? technology.label : '',
          typeOfInvestment: techPlan ? techPlan.typeOfInvestment : '',
          yearOfContract: techPlan ? techPlan.yearOfContract : '',
          purchaseOrInstallationPlan: techPlan ? techPlan.purchaseOrInstallationPlan : ''
        });
      }
    });
    props.questions.forEach(function (q) {
      if (q.technologyID && q.technologyID !== '' && techDupCheck.indexOf(q.technologyID.toString()) === -1) {
        techDupCheck.push(q.technologyID.toString());
        var technology = (0, _lodash.find)(props.technologiesList, {
          value: Number(q.technologyID)
        });
        var techPlan = (0, _lodash.find)(planValues, {
          technologyID: q.technologyID
        });
        rows.push({
          id: counter++,
          technologyID: q.technologyID,
          technologyName: technology ? technology.label : '',
          typeOfInvestment: techPlan ? techPlan.typeOfInvestment : '',
          yearOfContract: techPlan ? techPlan.yearOfContract : '',
          purchaseOrInstallationPlan: techPlan ? techPlan.purchaseOrInstallationPlan : ''
        });
      }
    });
    rows = (0, _lodash.sortBy)(rows, ['technologyName']);
    _this.state = {
      rows: rows
    };
    ['convertToValue', 'updateCheckbox'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomTechnologyPlans, _Component);
  return (0, _createClass2["default"])(CustomTechnologyPlans, [{
    key: "updateCheckbox",
    value: function updateCheckbox(id, field) {
      var _this2 = this;
      return function (value) {
        var rows = [].concat(_this2.state.rows);
        var idx = rows.findIndex(function (r) {
          return r.id === id;
        });
        rows[idx][field] = value.target.checked;
        if (!value.target.checked) {
          rows[idx]['typeOfInvestment'] = '';
          rows[idx]['yearOfContract'] = '';
        }
        _this2.setState({
          rows: rows
        });

        //Convert the rows array into a string value that can be saved off to the survey
        _this2.props.onChange(_this2.convertToValue(rows));
      };
    }
  }, {
    key: "updateRow",
    value: function updateRow(id, field) {
      var _this3 = this;
      return function (event, value) {
        var rows = [].concat(_this3.state.rows);
        var idx = rows.findIndex(function (r) {
          return r.id === id;
        });
        rows[idx][field] = value;
        _this3.setState({
          rows: rows
        });
        _this3.props.onChange(_this3.convertToValue(rows));
      };
    }
  }, {
    key: "convertToValue",
    value: function convertToValue(rows) {
      //Convert to array or arrays for simplicity when saving the surey values
      var value = rows.map(function (r) {
        return JSON.stringify({
          technologyID: r.technologyID,
          typeOfInvestmentID: r.typeOfInvestment.value,
          yearOfContractID: r.yearOfContract.value,
          purchaseOrInstallationPlan: r.purchaseOrInstallationPlan ? '298' : '' //298 is yes
        });
      });
      return value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        typesOfInvestment = _this$props.typesOfInvestment,
        yearOfContract = _this$props.yearOfContract,
        language = _this$props.language,
        resources = _this$props.resources;
      var rows = this.state.rows;
      var blankOption = [{
        label: '',
        value: ''
      }];
      return /*#__PURE__*/_react["default"].createElement(_material.Table, null, /*#__PURE__*/_react["default"].createElement("colgroup", null, /*#__PURE__*/_react["default"].createElement("col", {
        style: {
          width: '25%'
        }
      }), /*#__PURE__*/_react["default"].createElement("col", {
        style: {
          width: '28%'
        }
      }), /*#__PURE__*/_react["default"].createElement("col", {
        style: {
          width: '26%'
        }
      }), /*#__PURE__*/_react["default"].createElement("col", {
        style: {
          width: '26%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_material.TableHead, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
        style: {
          backgroundColor: '#fafafa'
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        className: classes.centerText
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Technology')), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        className: classes.centerText
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Purchase or Installation planned (with in 3 years)?')), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        className: classes.centerText
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Type of Investment')), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        className: classes.centerText
      }, (0, _getResource.getResource)(resources, language, 'Label', '(Planned) Year of Contract')))), /*#__PURE__*/_react["default"].createElement(_material.TableBody, null, rows.map(function (r) {
        var checked = r.purchaseOrInstallationPlan ? JSON.parse(r.purchaseOrInstallationPlan) : false;
        return /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
          key: r.id
        }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, (0, _getResource.getResource)(resources, language, 'Technology', r.technologyName)), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.centerText
        }, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
          className: classes.formControlLabel,
          key: r.id,
          control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, null),
          value: "".concat(r.purchaseOrInstallationPlan),
          checked: checked,
          label: "",
          onChange: _this4.updateCheckbox(r.id, 'purchaseOrInstallationPlan')
        })), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          name: "typeOfInvestment",
          value: r.typeOfInvestment,
          onChange: function onChange(value) {
            return _this4.updateRow(r.id, 'typeOfInvestment', value);
          },
          options: blankOption.concat(typesOfInvestment),
          isMulti: false,
          label: "",
          disabled: !r.purchaseOrInstallationPlan
        })), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          name: "yearOfContract",
          value: r.yearOfContract,
          onChange: function onChange(value) {
            return _this4.updateRow(r.id, 'yearOfContract', value);
          },
          options: blankOption.concat(yearOfContract),
          isMulti: false,
          label: "",
          disabled: !r.purchaseOrInstallationPlan
        })));
      })));
    }
  }]);
}(_react.Component);
CustomTechnologyPlans.propTypes = {
  value: _propTypes["default"].array,
  onChange: _propTypes["default"].func.isRequired,
  typesOfInvestment: _propTypes["default"].array.isRequired,
  yearOfContract: _propTypes["default"].array.isRequired,
  technologiesList: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomTechnologyPlans);